import { getNativeElementProps, slot, useArrowNavigationGroup } from '@fluentui/react-components';
// If you add JSX to this file, be sure to change the file type to .tsx
/**
 * Create the state required to render CopilotChat.
 *
 * The returned state can be modified with hooks such as useCopilotChatStyles_unstable,
 * before being passed to renderCopilotChat_unstable.
 *
 * @param props - props from this instance of CopilotChat
 * @param ref - reference to root HTMLElement of CopilotChat
 */
export const useCopilotChat_unstable = (props, ref) => {
  const arrowAttrs = useArrowNavigationGroup({
    memorizeCurrent: true,
    unstable_hasDefault: true
  });
  const state = {
    components: {
      root: 'div'
    },
    root: slot.always(getNativeElementProps('div', {
      ref,
      role: 'feed',
      ...props,
      ...arrowAttrs
    }), {
      elementType: 'div'
    })
  };
  return state;
};
//# sourceMappingURL=useCopilotChat.js.map